module.exports = __webpack_public_path__ + "img/f392209.webp";